/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { AccountTicket, UpdateAccountTicketRequest } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get tickets for an account.
 */
export const getAccountTickets = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<AccountTicket[]>>,
) => {
  return backofficeRequest<AccountTicket[]>(
    { url: `/api/v1/accounts/${billingAccountId}/tickets`, method: "GET" },
    options,
  )
}
/**
 * Replaces the ticket's definition, step, summary and description in Junifer (Junifer's PUT replaces all four, so send the current values for fields you are not changing). Only tickets linked to the billing account's Junifer account can be updated.
 * @summary Update a Junifer ticket on an account.
 */
export const updateAccountTicket = (
  billingAccountId: number,
  juniferTicketId: number,
  updateAccountTicketRequest: UpdateAccountTicketRequest,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/api/v1/accounts/${billingAccountId}/tickets/${juniferTicketId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateAccountTicketRequest,
    },
    options,
  )
}
export type GetAccountTicketsResult = NonNullable<
  Awaited<ReturnType<typeof getAccountTickets>>
>
export type UpdateAccountTicketResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountTicket>>
>
